import React from "react";
import { Routes, Route } from "react-router-dom";
import LoginPage from "../Pages/Authendication/LoginPage";

const AuthRoutes = () => {
  return (
      <Routes>
        <Route path="/" element={<LoginPage />} />
      </Routes>
  );
}

export default AuthRoutes;